export const SimplifiedChipsGrammar = {
  getExpression: (input) => {
    return {
        keyword: input.keyword? input.keyword.explain() : null,
        operator: input.operator? input.operator.explain() : null,
        operands: input.anything? input.anything.explain() : null
      }
  },
  Term: {
    explain(input) {
      return this.expression.explain(this.expression);
    }
  },
  FullExpression: {
    explain(input) {
      return SimplifiedChipsGrammar.getExpression(input);
    }
  },
  NoValueExpression: {
    explain(input) {
      return SimplifiedChipsGrammar.getExpression(input);
    }
  },
  NoOperatorExpression: {
    explain(input) {
      return SimplifiedChipsGrammar.getExpression(input);
    }
  },
  NoStructureExpression: {
    explain(input) {
      return SimplifiedChipsGrammar.getExpression(input);
    }
  },
  Keyword: {
    explain(input) {
      return this.text;
    }
  },
  Operator: {
    explain(input) {
      return this.text;
    }
  },
  Anything: {
    explain(input) {
      return this.text;
    }
  },
  PlainAscii: {
    explain(input) {
      return this.text;
    }
  },
  CommaList: {
    explain(input) {
      // see this definition of comma_list:
      // comma_list  <- first:any_value others:(__* "," __* any_value)*                   <CommaList>
      const result = [];
      // this is what is placed under 'first' label
      if (this.first) {
        result.push(this.first.explain());
      }

      // the 'others' label is created, wrapper TreeNode created. True content is in others.elements
      // Notice the PEG syntax used others:(.... any_value) syntax. So yet another  level of indirection
      // will be created. This is reflected in the code below
      // that wraps these options. Howe
      if (this.others && this.others.elements.length > 0) {
        this.others.elements.forEach((node) => {
          result.push(node.any_value.explain());
        });
      }
      return result;
    }
  },
  QuotedString: {
    explain(input) {
      if (this.elements.length > 2) {
        // we want just the text. no quotes
        return this.elements[1].text;
      }
      return '';
    }
  }
}
